module.exports = __webpack_public_path__ + "img/img-1.84afbaa2.png";